// extracted by mini-css-extract-plugin
module.exports = {"listTitle":"style_listTitle__5Ag5N"};